function data2treeDG(datas, dataArray, parentKey) {
  for (var j = 0; j < dataArray.length; j++) {
    var dataArrayIndex = dataArray[j];
    var childrenArray = [];
    var CATL_CODEP = dataArrayIndex.id;
    for (var i = 0; i < datas.length; i++) {
      var data = datas[i];
      var CATL_PARENT = data[parentKey];
      if (CATL_PARENT == CATL_CODEP) {//判断是否为儿子节点
        childrenArray.push(data);
      }
    }
    if (childrenArray.length > 0) {//有儿子节点则递归
      dataArrayIndex.children = childrenArray.sort(function (a, b) {
        if (a["moduleOrder"] > b["moduleOrder"]) {
          return 1
        } else {
          return - 1
        }
      });
      data2treeDG(datas, childrenArray, parentKey);
    }
  }
  return dataArray;
}

export default {
  signOut () {
    YJ_REGION_STORAGE.removeItem('token')
    YJ_REGION_STORAGE.removeItem('userInfo')
    YJ_REGION_STORAGE.removeItem('menus')
    YJ_REGION_STORAGE.removeItem('pathArray')
  },
  isLogin () {
    return !!YJ_REGION_STORAGE.getItem('token');
  },
  isAuth (name) {
    let pathArrayStr = YJ_REGION_STORAGE.getItem('pathArray') || '';
    pathArrayStr = pathArrayStr.replace(/City-/g, "Region-");
    const pathArray = JSON.parse(pathArrayStr);
    return pathArray && pathArray.indexOf(name) > -1;
  },
  /**
   * 将一维的扁平数组转换为多层级对象
   * @param  {[type]} list 一维数组，数组中每一个元素需包含id和parent_id两个属性
   * @sort 父节点在数组中的位置需要在子节点前，即 节点3必须排在节点3-2之前(可调用上面的compare方法)
   * @type 选择children为数组或对象
   * @return {[type]} tree 多层级树状结构
   */
  buildTree: function (list, parentKey) {
    let temp = {};
    let tree = {};
    for (let i in list) {
      temp[list[i].id] = list[i];
    }
    for (let i in temp) {
      if (temp[i][parentKey]) {
        if (!temp[temp[i][parentKey]].children) {
          temp[temp[i][parentKey]].children = new Array();
          // if (type === 'Object') temp[temp[i][parentKey]].children = new Object();
        }
        temp[temp[i][parentKey]].children.push(temp[i]);
        // temp[temp[i][parentKey]].children[temp[i].id] = temp[i];
      } else {
        tree[temp[i].id] = temp[i];
      }
    }
    return tree;
  },
  initDate() {
    Date.prototype.format = function (format) {
      var o = {
        "M+": this.getMonth() + 1,
        // month
        "d+": this.getDate(),
        // day
        "h+": this.getHours(),
        // hour
        "m+": this.getMinutes(),
        // minute
        "s+": this.getSeconds(),
        // second
        "q+": Math.floor((this.getMonth() + 3) / 3),
        // quarter
        "S": this.getMilliseconds()
        // millisecond
      };
      if (/(y+)/.test(format) || /(Y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    }
  },
  /**
   * 函数节流
   * @param func
   * @param wait
   * @param immediate
   * @returns {Function}
   */
  debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  // 格式化时间戳
  formatDate: function (timestamp, type = 'ymd') {
    if ((timestamp + '').indexOf('+0000') >= 0) {
      timestamp = timestamp.replace('+0000', '')
    }
    let date = new Date(timestamp)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let i = date.getMinutes()
    i = i < 10 ? ('0' + i) : i
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s

    switch (type) {
      case 'ymd': {
        return `${y}-${m}-${d}`
      }
      case 'ymdhi': {
        return `${y}-${m}-${d} ${h}:${i}`
      }
      default: {
        return `${y}-${m}-${d} ${h}:${i}:${s}`
      }
    }
  },
  //根据对象某一key值做排序
  compare: function (property) {
    return function (obj1, obj2) {
      var value1 = obj1[property];
      var value2 = obj2[property];
      return value1 - value2;     // 升序
    }
  },
  getDateDiff:function(dateTimeStamp){
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;
    var now = new Date().getTime();
    var diffValue = now - dateTimeStamp;
    if(diffValue < 0){return;}
    var monthC =diffValue/month;
    var weekC =diffValue/(7*day);
    var dayC =diffValue/day;
    var hourC =diffValue/hour;
    var minC =diffValue/minute;
    var result
    if(monthC>=1){
      result="" + parseInt(monthC) + "月前";
    }
    else if(weekC>=1){
      result="" + parseInt(weekC) + "周前";
    }
    else if(dayC>=1){
      result=""+ parseInt(dayC) +"天前";
    }
    else if(hourC>=1){
      result=""+ parseInt(hourC) +"小时前";
    }
    else if(minC>=1){
      result=""+ parseInt(minC) +"分钟前";
    }else
    result="刚刚";
    return result;
  },
  format: function (num) {
    var reg = /\d{1,3}(?=(\d{3})+$)/g;
    return (num + '').replace(reg, '$&,');
  },

  serializeGrade(gradeId) {
    let grades = [
      "一年级",
      "二年级",
      "三年级",
      "四年级",
      "五年级",
      "六年级",
      "初一年级",
      "初二年级",
      "初三年级",
      "高一年级",
      "高二年级",
      "高三年级"
    ];
    return grades[gradeId - 1];
  },
}

export const isEmpty = obj => {
  return typeof obj == "undefined" || obj == null || obj === "";
}

export const deepClone = data => {
  return JSON.parse(JSON.stringify(data));
}

/**
 * 检测是否存在重叠词
 * 如重叠词AAB、BB
 * @param {*} answer
 * @returns
 */
export const isReduplication = (answer) => {
  let repeat = false;
  for (let i = 0; i < answer.length; i++) {
    let remain = answer.substr(i + 1);
    if (remain.indexOf(answer.charAt(i)) > -1) {
      repeat = true;
      break;
    }
  }
  return repeat;
}

export const sortAnswer = answer => {
  return answer.split('').sort((a, b) => {
    if (a > b) {
      return 1;
    } else {
      return -1;
    }
  }).join('');
}




// WEBPACK FOOTER //
// ./src/utils/index.js